// config.js

export const DEFAULT_TEXT = "The quick brown fox jumps over the lazy dog.";

export const DEFAULT_VIEW = "single";

export const DEFAULT_FONT = "cps-momentum";

export const DEFAULT_STYLE = "regular";

export const DEFAULT_FONT_SIZE = 30;

export const DEFAULT_LINE_HEIGHT = 1.3;

export const DEFAULT_TRACKING = 0;

export const MIN_FONT_SIZE = 8;
export const MAX_FONT_SIZE = 200;

export const MIN_TRACKING = -20;
export const MAX_TRACKING = 200;

export const MIN_LINE_HEIGHT = 0.8;
export const MAX_LINE_HEIGHT = 2.5;

export const AVAILABLE_VIEWS = [
  "single",
  "paragraph",
  "waterfall",
  "grid",
];

export const WATERFALL_SCALE_STEPS = [1, 1.25, 1.6, 2, 2.6, 3.0];
export const MOBILE_WATERFALL_SCALE_STEPS = [0.75, 1.25, 2, 4];
